import React, { useState, useEffect, useRef } from 'react'
import { Loader2 } from 'lucide-react'
import { Button } from '../ui/button'

export default function RsvpButton({ isRsvped, count, onToggle, disabled = false }) {
  const [loading, setLoading] = useState(false)
  const [optimistic, setOptimistic] = useState(null) // { rsvped, count } or null

  // When parent props update (after refetch), clear optimistic state
  const prevPropsRef = useRef({ isRsvped, count })
  useEffect(() => {
    const prev = prevPropsRef.current
    if (prev.isRsvped !== isRsvped || prev.count !== count) {
      setOptimistic(null)
    }
    prevPropsRef.current = { isRsvped, count }
  }, [isRsvped, count])

  const displayRsvped = optimistic ? optimistic.rsvped : isRsvped
  const displayCount = optimistic ? optimistic.count : count

  const handleClick = async (e) => {
    e.stopPropagation()
    if (loading || disabled) return

    // Optimistic update
    const newRsvped = !displayRsvped
    const newCount = newRsvped ? displayCount + 1 : Math.max(0, displayCount - 1)
    setOptimistic({ rsvped: newRsvped, count: newCount })
    setLoading(true)

    try {
      await onToggle()
      // Don't reset optimistic here — wait for parent props to update
    } catch {
      // Revert on error
      setOptimistic(null)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      size="sm"
      variant="outline"
      onClick={handleClick}
      disabled={loading || disabled}
      className={
        displayRsvped
          ? 'bg-gold text-black border-gold hover:bg-gold/90'
          : 'text-charcoal border-gold/50 hover:border-gold hover:bg-gold/5'
      }
    >
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin mr-1" />
      ) : null}
      {displayRsvped ? 'Going' : 'RSVP'} ({displayCount})
    </Button>
  )
}
